 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import A1_TITLE from '@/components/01_Title'
 import UNTITLED332 from '@/components/Untitled-3-32'
 import UNTITLED333 from '@/components/Untitled-3-33'
 import UNTITLED334 from '@/components/Untitled-3-34'
 import UNTITLED335 from '@/components/Untitled-3-35'
 import UNTITLED336 from '@/components/Untitled-3-36'
 import UNTITLED337 from '@/components/Untitled-3-37'
 import UNTITLED338 from '@/components/Untitled-3-38'
 import UNTITLED339 from '@/components/Untitled-3-39'
 import UNTITLED340 from '@/components/Untitled-3-40'
 import UNTITLED341 from '@/components/Untitled-3-41'
 import UNTITLED342 from '@/components/Untitled-3-42'
 import UNTITLED343 from '@/components/Untitled-3-43'
 import UNTITLED344 from '@/components/Untitled-3-44'
 import UNTITLED345 from '@/components/Untitled-3-45'
 import UNTITLED346 from '@/components/Untitled-3-46'
 import UNTITLED347 from '@/components/Untitled-3-47'
 import UNTITLED348 from '@/components/Untitled-3-48'
 import UNTITLED349 from '@/components/Untitled-3-49'
 import UNTITLED350 from '@/components/Untitled-3-50'
 import UNTITLED351 from '@/components/Untitled-3-51'
 import UNTITLED352 from '@/components/Untitled-3-52'
 import UNTITLED353 from '@/components/Untitled-3-53'
 import UNTITLED354 from '@/components/Untitled-3-54'
 import UNTITLED355 from '@/components/Untitled-3-55'
 import UNTITLED356 from '@/components/Untitled-3-56'
 import UNTITLED357 from '@/components/Untitled-3-57'
 import UNTITLED358 from '@/components/Untitled-3-58'
 import UNTITLED359 from '@/components/Untitled-3-59'
 import UNTITLED360 from '@/components/Untitled-3-60'
 import UNTITLED361 from '@/components/Untitled-3-61'
 import UNTITLED362 from '@/components/Untitled-3-62'
 import LOVE_2 from '@/components/love_2'
 import PREVIEWPREVIEW from '@/components/Preview/Preview'
 import PREVIEWPREVIEWCOVER from '@/components/Preview/previewcover'
 import PREVIEWUNTITLED435 from '@/components/Preview/Untitled-4-35'
 import PREVIEWUNTITLED436 from '@/components/Preview/Untitled-4-36'
 import PREVIEWUNTITLED437 from '@/components/Preview/Untitled-4-37'
 import A9_COPYRIGHT from '@/components/99_Copyright'
 import AUBA from '@/components/auba'
 import A00_ORIMAD from '@/components/100_ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/01_Title",
 			"name" : "01_Title",
 			"component" : A1_TITLE
 		},
 		{
 			"path" : "/Untitled-3-32",
 			"name" : "Untitled-3-32",
 			"component" : UNTITLED332
 		},
 		{
 			"path" : "/Untitled-3-33",
 			"name" : "Untitled-3-33",
 			"component" : UNTITLED333
 		},
 		{
 			"path" : "/Untitled-3-34",
 			"name" : "Untitled-3-34",
 			"component" : UNTITLED334
 		},
 		{
 			"path" : "/Untitled-3-35",
 			"name" : "Untitled-3-35",
 			"component" : UNTITLED335
 		},
 		{
 			"path" : "/Untitled-3-36",
 			"name" : "Untitled-3-36",
 			"component" : UNTITLED336
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js